module.exports = __webpack_public_path__ + "static/media/Education _Fund.2d885549.jpeg";